//Constantes para el uso del Mapbox Geocoding API
export const UbicacionMapaService = {
    urlMapa: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=',
    atribucionMapa: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    urlBusqueda: 'http://api.mapbox.com/geocoding/v5/mapbox.places/',
    parametrosBusqueda: '.json?limit=5&country=ec&access_token=',
    apiToken: 'pk.eyJ1IjoianNvbmJvdXJuZTMzIiwiYSI6ImNra2t0cmhqdzBlamcyb2xzZG55Nzl0YXYifQ.ca0MmNphBgGyQyRP2cT9nQ'
};